import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Execution.module.css';

const execution = (props) => {
    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (props.selected === 'NewExecutionList') {
        header_icon = (<div className={classes.AddCircle}><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }
    return (
        <div className={"card "+ classes.Execution +" "+props.selected} onClick={props.clicked}>
            <h4 className="card-header">{props.name} {header_icon}</h4>
            <div className="card-body">
                <div className={"cardText "+classes.truncate}>
                    Execution Seed: {props.seed} <br/>
                    Exercise completed By: {props.authors} <br/>
                    On: {props.date}
                </div>
            </div>
        </div>
    );
};

export default execution;